import LogOptions from 'telemetry/lib/schema/LogOptions';
import { AppError } from 'mini-app-context/lib/schema/AppError';
import { lazyGetWorkflowSignalManager } from 'mini-workflow-manager';

export default async (
    name: string,
    inputPayload?: any,
    options?: LogOptions,
    error?: AppError
): Promise<void> => {
    const workflowManager = await lazyGetWorkflowSignalManager.importAndExecute();
    return workflowManager.signal(name, inputPayload, options, error);
};
